// extracted by mini-css-extract-plugin
export default {"container":"Home_container__8hQ4f","sidebar":"Home_sidebar__HYXwI"};